export default __webpack_public_path__ + "static/media/overview.83027a34.svg";